import { createAction, props } from '@ngrx/store';
import { DashboardFilterDTO } from '../../dto/dashboard/dashboard.dto';
import { WidgetSettings } from '../../components/duna/duna-dashboard/duna-dashboard.component';

export const loadDashboardWidgetData = createAction(
  '[Dashboard] Load Widget Data',
  props<{ 
    widgetType: string; 
    dataSource: string; 
    filters?: DashboardFilterDTO;
    forceRefresh?: boolean; 
  }>()
);

export const loadDashboardWidgetDataSuccess = createAction(
  '[Dashboard] Load Widget Data Success',
  props<{ 
    widgetType: string; 
    dataSource: string; 
    filters?: DashboardFilterDTO;
    data: any;
  }>()
);

export const loadDashboardWidgetDataFailure = createAction(
  '[Dashboard] Load Widget Data Failure',
  props<{ 
    widgetType: string; 
    dataSource: string; 
    filters?: DashboardFilterDTO;
    error: any;
  }>()
);

export const clearDashboardWidgetData = createAction(
  '[Dashboard] Clear Widget Data',
  props<{ 
    widgetType?: string;
  }>()
);

export const refreshAllDashboardWidgetData = createAction(
  '[Dashboard] Refresh All Widget Data'
);

// User-specific widget configuration actions
export const setCurrentUser = createAction(
  '[Dashboard] Set Current User',
  props<{ userId: string }>()
);

export const loadUserWidgetConfigs = createAction(
  '[Dashboard] Load User Widget Configs',
  props<{ userId: string }>()
);

export const loadUserWidgetConfigsSuccess = createAction(
  '[Dashboard] Load User Widget Configs Success',
  props<{ 
    userId: string;
    configs: {
      [widgetId: string]: {
        settings: WidgetSettings;
        position?: {
          x: number;
          y: number;
          cols: number;
          rows: number;
        };
      }
    } 
  }>()
);

export const loadUserWidgetConfigsFailure = createAction(
  '[Dashboard] Load User Widget Configs Failure',
  props<{ error: any }>()
);

export const saveUserWidgetConfig = createAction(
  '[Dashboard] Save User Widget Config',
  props<{ 
    userId: string;
    widgetId: string;
    settings: WidgetSettings;
    position?: {
      x: number;
      y: number;
      cols: number;
      rows: number;
    };
  }>()
);

export const saveUserWidgetConfigSuccess = createAction(
  '[Dashboard] Save User Widget Config Success',
  props<{ 
    userId: string;
    widgetId: string;
  }>()
);

export const saveUserWidgetConfigFailure = createAction(
  '[Dashboard] Save User Widget Config Failure',
  props<{ 
    userId: string;
    widgetId: string;
    error: any;
  }>()
);

export const clearUserWidgetConfigs = createAction(
  '[Dashboard] Clear User Widget Configs',
  props<{ userId?: string }>()
); 